import keyMirror from 'keymirror';

export const lookupTypes = keyMirror({
  'TICKET': null,
  'FREQUENT_FLYER': null,
});
